<template>
    <div class="social-organic-performance-highlights mt-5">
        <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>
        <div v-if="!has_data && !reloading" class="nodata-container p-5 text-center">
            <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
            <template v-if="errors">
                <div class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
            </template>
            <template v-else>
                <template v-if="missed_fb_accounts && missed_inst_accounts">
                    <div class="missed-accounts my-3">There are no accounts connected for both Facebook Insights and Instagram. Either connect an account or change the metrics/remove this section in the builder.</div>
                </template>
                <template v-else>
                    <div v-if="missed_fb_accounts" class="missed-accounts my-3">There are no accounts connected for Facebook Insights. Either connect an account or change the metrics/remove this section in the builder.</div>
                    <div v-if="missed_inst_accounts" class="missed-accounts my-3">There are no accounts connected for Instagram. Either connect an account or change the metrics/remove this section in the builder.</div>
                </template>
                <div class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
            </template>
        </div>
        <template v-if="has_data">
        <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
            <template v-if="missed_fb_accounts && missed_inst_accounts">
                <div class="missed-accounts my-3">There are no accounts connected for both Facebook Insights and Instagram. Either connect an account or change the metrics/remove this section in the builder.</div>
            </template>
            <template v-else>
                <div v-if="missed_fb_accounts" class="missed-accounts my-3">There are no accounts connected for Facebook Insights. Either connect an account or change the metrics/remove this section in the builder.</div>
                <div v-if="missed_inst_accounts" class="missed-accounts my-3">There are no accounts connected for Instagram. Either connect an account or change the metrics/remove this section in the builder.</div>
            </template>
        <h4 class="section-name my-3 text-uppercase">{{sophData.name}}</h4>
        <div class="row boxes-wrap likes justify-content-around mt-5 mb-0">
            <div v-for="(like, idx) in top_likes" class="box-col likes flex-grow-1 d-flex justify-content-center" :class="'box_'+ ++idx">
                <div class="box-header">TOP POST</div>
                <div class="metrics-box" :class="like.social">
                    <p><span class="metric-name">Likes:</span><span class="metric-value">{{like.like}}</span></p>
                    <p v-if="like.social=='fb'"><span class="metric-name">Shares:</span><span class="metric-value">{{like.shares}}</span></p>
                    <p><span class="metric-name">Impressions:</span><span class="metric-value">{{like.impressions}}</span></p>
                </div>
                <div class="img-wrap d-flex flex-column">
                    <div class="comment-wrap" :class="like.social">
                        <img v-if="like.social=='inst'" :src="$store.state.app_url+'/images/social/instagram/header.png/'" />
                        <img class="dots" :src="$store.state.app_url+'/images/social/dots.png'" />
                        <img class="client-logo" :src="$store.state.app_url+'/images/client_logos/'+like.client_logo" />
                        <span class="account-name">{{like.account_name}}<span class="date">{{like.date}} <img class="globe" :src="$store.state.app_url+'/images/social/globe.png'" /></span></span>
                        <template v-if="show_full_like">
                            <span v-if="like.social=='fb'" class="message mt-2" v-html="like.full_message" @mouseleave="hideFullLike">{{like.full_message}}</span>
                        </template>
                        <template v-else>
                            <span v-if="like.social=='fb'" class="message mt-2" v-html="like.message" @mouseover="showFullLike">{{like.message}}</span>
                        </template>
                    </div>
                    <img remote :src="like.full_picture" />
                    <div v-if="like.social=='fb'" class="socials d-flex justify-content-around mt-3">
                        <span><img :src="$store.state.app_url+'/images/social/facebook/like.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/facebook/comment.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/facebook/share.png'" /></span>
                    </div>
                    <div v-if="like.social=='inst'" class="socials d-flex justify-content-around mt-3">
                        <span><img :src="$store.state.app_url+'/images/social/instagram/like.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/instagram/comment.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/instagram/share.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/instagram/save.png'" /></span>
                    </div>
                    <div v-if="like.social=='inst'" class="comment-wrap">
                        <template v-if="show_full_like">
                            <span class="message mt-2" v-html="like.full_message" @mouseleave="hideFullLike">{{like.full_message}}</span>
                        </template>
                        <template v-else>
                            <span class="message mt-2" v-html="like.message" @mouseover="showFullLike">{{like.message}}</span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!!most_shares" class="row boxes-wrap shares justify-content-around mb-5 mt-0">
            <div class="flex-grow-1 d-flex justify-content-center box-col shares box_1">
                <div class="box-header">ENGAGEMENT HIGHLIGHT</div>
                <div class="img-wrap shares d-flex flex-column">
                    <div class="comment-wrap">
                        <img class="dots" :src="$store.state.app_url+'/images/social/dots.png'" />
                        <img class="client-logo" :src="$store.state.app_url+'/images/client_logos/'+most_shares.client_logo" />
                        <span class="account-name">{{most_shares.account_name}}<span class="date">{{most_shares.date}} <img class="globe" :src="$store.state.app_url+'/images/social/globe.png'" /></span></span>
                        <template v-if="show_full_message">
                            <span class="message mt-2" v-html="most_shares.full_message" @mouseleave="hideFullMessage">{{most_shares.full_message}}</span>
                        </template>
                        <template v-else>
                            <span class="message mt-2" v-html="most_shares.message" @mouseover="showFullMessage">{{most_shares.message}}</span>
                        </template>
                    </div>
                    <img remote :src="most_shares.full_picture" style="margin-top:10px;" />
                    <div class="socials d-flex justify-content-around mt-3">
                        <span><img :src="$store.state.app_url+'/images/social/facebook/like.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/facebook/comment.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/facebook/share.png'" /></span>
                    </div>
                </div>
            </div>
            <div class="flex-grow-1 d-flex justify-content-center box-col shares box_2">
                <div class="box-header">BOOSTED POST</div>
                <div class="img-wrap shares d-flex flex-column">
                    <div class="comment-wrap">
                        <template v-if="!!boosted">
                            <img class="dots" :src="$store.state.app_url+'/images/social/dots.png'" />
                            <img class="client-logo" :src="$store.state.app_url+'/images/client_logos/'+boosted.client_logo" />
                            <span class="account-name">{{boosted.account_name}}<span class="date">{{boosted.date}} <img class="globe" :src="$store.state.app_url+'/images/social/globe.png'" /></span></span>
                            <template v-if="show_full_message">
                                <span class="message mt-2" v-html="boosted.full_message" @mouseleave="hideFullMessage">{{boosted.full_message}}</span>
                            </template>
                            <template v-else>
                                <span class="message mt-2" v-html="boosted.message" @mouseover="showFullMessage">{{boosted.message}}</span>
                            </template>
                        </template>
                    </div>
                    <img v-if="!!boosted" remote :src="boosted.full_picture" />
                    <div v-if="!!boosted" class="socials d-flex justify-content-around mt-3">
                        <span><img :src="$store.state.app_url+'/images/social/facebook/like.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/facebook/comment.png'" /></span>
                        <span><img :src="$store.state.app_url+'/images/social/facebook/share.png'" /></span>
                    </div>
                </div>
            </div>
            <div class="flex-grow-1 d-flex justify-content-center box-col shares box_3">
                <div class="box-header">COMMENT HIGHLIGHTS</div>
                <div class="img-wrap shares">
                    <p v-for="comment in most_comments" class="most-comment" v-html="comment.message">{{comment.message}}</p>
                </div>
            </div>
        </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'sophData'],
        created() {
            if(this.isBuilt){
                event_bus.$on('current_dwm', () => {
                    this.current_dwm = this.$store.state.current_dwm;
                    event_bus.$emit('reloading', true);
                });
                this.fetchServerData();
            }
        },
        data() {
            return {
                top_likes:null,
                most_shares:null,
                boosted:null,
                most_comments:null,
                has_data:null,
                missed_fb_accounts:false,
                missed_inst_accounts:false,
                show_full_like:false,
                show_full_message:false,
                errors:false,
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true
            }
        },
        mounted() {
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.sophData.report_id,
                    'element_abbr':this.sophData.element_abbreviation,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.sophData.element_id,
                    'prefixed_element_id': this.sophData.report_element_id,
                    'element_name': this.sophData.name,
                    'client_id':this.sophData.client_id,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                };
                axios.post('/api/reporting/element', params).then((response) => {
                    this.errors = response.data.errors;
                    this.top_likes = response.data.top_likes;
                    this.most_shares = response.data.most_shares;
                    this.boosted = response.data.boosted;
                    this.most_comments = response.data.most_comments;
                    this.query = response.data.query;
                    this.has_data = response.data.has_data;
                    this.missed_fb_accounts = !response.data.fb_accounts;
                    this.missed_inst_accounts = !response.data.inst_accounts;
                    this.reloading = false;
                });
                this.reloading = false;
            },
            showFullLike(){
                this.show_full_like = true;
            },
            hideFullLike(){
                this.show_full_like = false;
            },
            showFullMessage(){
                this.show_full_message = true;
            },
            hideFullMessage(){
                this.show_full_message = false;
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    .social-organic-performance-highlights{
        div.boxes-wrap{
            font-family:Helvetica, Arial, sans-serif;
            padding-bottom:0;
            &.likes{
                border-bottom:0.1rem solid $black-blue;
            }
            div.box-col{
                position:relative;
                @media (min-width: 1100px) {
                    &.box_1{
                        border-right:0.1rem solid $black-blue;
                    }
                    &.box_3{
                        border-left:0.1rem solid $black-blue;
                    }
                }

                &.likes{
                    padding-bottom:2rem;
                    padding-top:6rem
                }
                &.shares{
                    padding-top:6rem;
                }
                div.box-header{
                    position:absolute;
                    top:1rem;
                    border:0.2rem solid $black-blue;
                    padding:0.5rem 1rem;
                    border-radius:2rem;
                    font-size:1.4rem;
                    font-weight:bold;
                }
                div.metrics-box{
                    position:absolute;
                    top:50%;
                    right:10%;
                    padding:0.5rem 2rem;
                    border-radius:2rem;
                    font-size:1.2rem;
                    background-color:white;
                    box-shadow: 0.4rem 0.4rem 0.5rem #afafaf;
                    z-index:9;
                    p{
                        padding:0;
                        margin:0;
                        span.metric-name{
                            font-weight:bold;
                        }
                    }
                    &.inst{
                        border-radius:1rem;
                    }
                }
            }

            div.img-wrap{
                padding-bottom:1rem;
                border:0.1rem solid $light-blue;
                img, div.comment-wrap{
                    position:relative;
                    max-width: 30rem;
                    font-size:1.4rem;
                    span{
                        display:inline-block;
                        padding:1rem;
                        &.account-name{
                            font-size:1.2rem;
                            font-weight:bold;
                            position:relative;
                            span.date{
                                position:absolute;
                                width:100%;
                                min-width:16rem;
                                bottom:-2rem;
                                font-weight:normal;
                                left:0;
                                img.globe{
                                    max-width:1rem;
                                    margin-top:-0.2rem;
                                }
                            }
                        }
                        b.more{
                            paddind:0;
                            font-size:1.2rem;
                            color:$gray-dark;
                        }
                    }
                    img.client-logo{
                        max-width:3rem;
                        margin-left:1rem;
                        border:0.1rem solid $gray;
                        border-radius:50%;
                    }
                    img.dots{
                        position:absolute;
                        top:0.8rem;
                        right:0.5rem;
                        max-height:0.4rem;
                    }
                    &.inst{
                        min-height:10rem;
                        img.dots{
                            top:4.2rem;
                        }
                    }
                }
                div.socials{
                    max-width: 30rem;
                    span{
                        display:inline-block;
                        img{
                            max-height:2rem;
                        }
                    }
                }
                &.shares{
                    min-width:30.2rem;
                }
                p.most-comment{
                    padding:0.5rem;
                    margin:0.4rem;
                    font-size:1.4rem;
                    max-width:29.2rem;
                    border:0.1rem solid $gray;
                }
            }
        }
    }
</style>
